export const inputStylingProps = {
  fieldClassName: "text-primary-50 gap-y-[6px]",
  inputClassName: "bg-primary-700 text-primary-50 placeholder-primary-400",
  containerClassName: "border-primary-400 bg-primary-700",
}
